import { useState, useEffect } from 'react';
import { useTranslation } from '../i18n';

export const useSlogan = () => {
  const t = useTranslation();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % t.slogans.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [t.slogans.length]);

  return t.slogans[index];
};
